import { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/StylesHeader.css';
import '../css/HorizontalMenu.css'; // Import your custom CSS for the menu
const host = process.env.REACT_APP_API_HOST_COLOR_COMMENT;

const HeaderMenu = ({ title, subtitle, updateTitle }) => {
  // console.log(title);
  // console.log(updateTitle);
  const [menuData, setMenuData] = useState([]);
  const [pengguna, setPengguna] = useState("");
  const [role, setRole] = useState("");
  const [currentDate, setCurrentDate] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const token = localStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  function toSentenceCase(str) {
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const toggleDropdown = () => {
    setShowDropdown(prevState => !prevState);
  };

  const getColumnNames = async () => {
    try {
      const response = await axios.post(`${host}ReactMenu`, null, config);
      setMenuData(response.data); // Set the menuData state with the fetched data
      //console.log('test data:', response.data);
    } catch (error) {
      console.error('Error fetching column names:', error);
    }
  };
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    const pengguna = localStorage.getItem('pengguna');
    const role = localStorage.getItem('role');
    setPengguna(toSentenceCase(pengguna));
    setRole(role);
    if (token) {
      getColumnNames();
    }

    const updateDate = () => {
      const today = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDate = today.toLocaleDateString('ID', options);
      setCurrentDate(formattedDate);
    };
    updateDate();
    const intervalId = setInterval(updateDate, 1000);
    return () => clearInterval(intervalId);

  }, []);


  //console.log("menu ", Object.keys(menuData));

  return (
    <header key="1" id="1">
      <div className="container-main-view">
        <div className="header">
          <div className="icon">
            <img src='/images/SS88.png' height="35" alt="Icon" />
          </div>
          <div className="title">
            <h1 className='docs-title-widget'>{title}</h1>
            <div className="menu">
              <ul className="horizontal-menu">
                {Object.keys(menuData)
                  .sort((a, b) => menuData[a].posisi - menuData[b].posisi) // Sort categories by posisi
                  .map((menuCategory) => (
                    <li key={menuCategory}>
                      <span className="menu-category">{menuCategory}</span>
                      <ul className="submenu">
                        {menuData[menuCategory]["data"].map((menuItem, index) => (
                          <li key={`${menuCategory}-${index}`}>
                            <a href={menuItem.link}>
                              <i className={menuItem.icon} /> {menuItem.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                  
              </ul>
            </div>
          </div>
          <div className="iconprofils" style={{ verticalAlign: 'top', display: 'flex', alignItems: 'center' }}>
            <div style={{ float: 'right', textAlign: 'right', marginRight: '10px' }}>
              <span onClick={toggleDropdown}>Hallo, {pengguna} </span>
              <div style={{ marginBottom: '-5px' }}></div>
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{role} | {currentDate} </span>
            </div>
            <img id="image_loading" style={{ display: 'none' }} src="/app-assets/css/loadi.gif" height="32" alt="Icon" />
            <img src="/images/personal.png" height="35" alt="Icon" title="User" onClick={toggleDropdown} />
            {showDropdown && (
              <div className="dropdown-menu">
                {/* Dropdown menu content */}
                <ul>
                  <li><a href="/User_change_pass">Change Pass</a></li>
                  <li><a href="/Logout">Logout</a></li>
                  {/* <li>Option 2</li> */}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderMenu;